(function(){
  var sec = document.querySelector('[data-gdp-x]');
  var src = document.querySelector('[data-gdp-scent-label]');
  if(!sec) return;

  function sync(){
    var scent = src ? (src.textContent || '').trim() : '';
    Array.prototype.forEach.call(sec.querySelectorAll('[data-x-card]'), function(card){
      var mapEl = card.querySelector('[data-x-map]');
      var match = card.querySelector('[data-x-match]');
      var base = card.getAttribute('data-base');
      if(!mapEl){ return; }
      var M; try { M = JSON.parse(mapEl.textContent); } catch(e){ return; }
      card.href = base;
      if(match){ match.hidden = true; match.textContent = ''; }
      if(!scent || M.scentIdx < 0) return;
      for(var i=0;i<M.variants.length;i++){
        var v = M.variants[i];
        if(v.available && v.opts[M.scentIdx] === scent){
          card.href = base + '?variant=' + v.id;
          if(match){ match.textContent = 'Also in ' + scent; match.hidden = false; }
          return;
        }
      }
    });
  }

  sync();
  if(src && 'MutationObserver' in window){
    new MutationObserver(sync).observe(src, { childList: true, characterData: true, subtree: true });
  }
})();
